import React from "react";
import AutoplayVideo from "storefront/components/AutoplayVideo";
import Headline from "storefront/components/Headline";
import styles from "./NotFoundPage.module.scss";

const TRANSPARENT_POSTER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

const NotFoundPage = () => (
  <div className={styles.page}>
    <div className={styles.group}>
      <div className={styles.center}>
        <AutoplayVideo
          className={styles.blobGif}
          sources={[]}
          fallback={{
            srcSet: [
              {
                src: "https://assets.grailed.com/404-blob.mp4",
                type: "video/mp4",
              },
            ],
            poster: TRANSPARENT_POSTER,
            description: "",
          }}
        />
        <AutoplayVideo
          className={styles.logoGif}
          sources={[]}
          fallback={{
            srcSet: [
              {
                src: "https://assets.grailed.com/grailed-logo-spin.mp4",
                type: "video/mp4",
              },
            ],
            poster: TRANSPARENT_POSTER,
            description: "Grailed",
          }}
        />
      </div>
      <Headline as="p" className={styles.message}>
        Apologies, we couldn&apos;t find that page.
      </Headline>
    </div>
  </div>
);

export default NotFoundPage;
